export const doMain = process.env.NODE_ENV == 'production' ? 'ule.com' : 'beta.ule.com';
export const cdnDoMain = process.env.NODE_ENV == 'production' ? 'ulecdn.com' : 'beta.ulecdn.com';
// const doMain = 'ule.com';
console.log(process.env.NODE_ENV)
console.log(doMain)
export const datetime = '//pub.' + doMain + '/clock/datetime'; //获取系统时间
export const getActivityInfos = '//static-content.' + cdnDoMain + '/yxdcdn/act/redenvelopes/getActivityInfos/'; //获取活动场次
export const querySingCount = '//prize.' + doMain + '/mc/m/api/v3/base/sign/querySingCount'; //签到次数查询接口
export const signup = '//service.' + doMain + '/appact/signin/signup'; //签到接口
export const getIndexCookies = '//my.' + doMain + '/usr/getIndexCookies.do'; //获取cookie信息接口
export const getActivityTimes = '//service.' + doMain + '/appact/redenvelopes/getActivityTimes'; //抽奖资格查询
export const lottry = '//service.' + doMain + '/appact/redenvelopes/lottry'; //抽奖接口
export const dwRecommond = '//ustatic.ulecdn.com/mobilead/v2/recommend/dwRecommond/'; //推荐位接口,2001普通商品推荐位，2002广告推荐位
export const getBatchActivityTimes = '//service.' + doMain + '/appact/redenvelopes/getBatchActivityTimes'; //获取下单赢大奖模块抽奖资格


// WEBPACK FOOTER //
// ./src/assets/js/url.js